export const seoContentTabsArticle = {
  title: 'SEO Content Hub: Tabs & Workflow',
  slug: 'seo-content-tabs',
  content: `SEO Content Hub: Tabs & Workflow

Move from research to publishing in one flow.

1) Topical Authority
- Use Topical Authority to plan clusters.
- Generate post ideas and move to Blog Creator.

2) Blog Creator
- Draft posts with SEO controls and outlines.
- Save drafts to the Content Library.

3) Content Library
- Review saved drafts and published content.

Tip
- Tabs are hash-based (#topical-authority, #blog-creator, #content-library).
`,
};
